import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { TOK, SERIF, SANS } from "../soulumoCreate/shared";
import { API, auth, ADELAIDA_IMG } from "./DemoBits";

// Create page: members see the real create box; free members get the guided demo with Adelaida.
export const MembersOrDemo = ({ children }) => {
  const nav = useNavigate();
  const [free, setFree] = useState(null);
  useEffect(() => { axios.get(`${API}/api/voice-clone/me`, auth()).then((r) => setFree(!!r.data.needs_membership)).catch(() => setFree(false)); }, []);
  if (free === null) return null;
  if (!free) return children;
  return (
    <section className="pt-6 text-center" data-testid="demo-invite">
      <img src={ADELAIDA_IMG} alt="Adelaida" className="mx-auto w-32 h-32 rounded-full object-cover object-top" />
      <h1 className="mt-6 text-4xl sm:text-5xl font-light leading-tight" style={{ fontFamily: SERIF, color: TOK.cream }}>See how Soulumo works</h1>
      <p className="mt-4 text-lg leading-relaxed max-w-md mx-auto" style={{ fontFamily: SERIF, color: TOK.creamDim }}>
        Follow Andrew as Adelaida listens, writes his affirmations and creates his installation in his own voice. Then make it yours.
      </p>
      <button type="button" onClick={() => nav("/soulumo/demo")} data-testid="demo-invite-start"
        className="mt-8 w-full max-w-sm rounded-full py-4 text-[0.74rem] uppercase tracking-[0.26em] transition-transform duration-200 active:scale-[0.98]"
        style={{ background: TOK.gold, color: "#0d1f3a", fontFamily: SANS }}>Start the two-minute demo</button>
      <button type="button" onClick={() => nav("/soulumo/demo?step=pay")} data-testid="demo-invite-join"
        className="mt-4 block mx-auto text-sm underline" style={{ color: TOK.creamDim, fontFamily: SANS }}>I'm ready, create mine</button>
    </section>
  );
};
